import React from 'react'
import { ModeratorViewListedItemDetailsComponentProps } from './moderator-view-listed-item-details-component.types'
import { useModeratorViewListedItemDetailsComponentStyles } from './moderator-view-listed-item-details-component.styles'
import Grid from '@material-ui/core/Grid'
import { ItemImageSlider } from '../../../shared/item-image-slider'
import { InfoComponent } from './info-component/info-component'
import { EmptyImageComponent } from './empty-image-component'
import Skeleton from '@material-ui/lab/Skeleton'
import Box from '@material-ui/core/Box'

export const ModeratorViewListedItemDetailsComponent: React.FC<ModeratorViewListedItemDetailsComponentProps> =
  (props: ModeratorViewListedItemDetailsComponentProps) => {
    const {
      isCurrentUserOwner,
      images,
      itemCondition,
      currency,
      description,
      locale,
      currentPrice,
      name,
      nonprofitName,
      nonprofitUrl,
      donorName,
      listedUtc,
      createdUtc,
      soldUtc,
      state,
      listedItemId,
      loading,
      city,
      region,
      deliveryType,
      isLocalPickupAvailable,
      isShippingAvailable,
      setInStoreDeliveryType,
    } = props
    const classes = useModeratorViewListedItemDetailsComponentStyles()

    //Placeholder
    const placeholderBlock = () => (
      <div>
        <Box pt={0.5}>
          <Skeleton className={classes.imgSkeleton} animation="wave" />
        </Box>
      </div>
    )

    //Img Block
    const imgBlock = () =>
      images && images.length ? (
        <ItemImageSlider images={images} variant="public" />
      ) : (
        <EmptyImageComponent />
      )

    return (
      <div className={classes.wrapper}>
        <div className={classes.sliderBlock}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={7} className={classes.sliderSectionBig}>
              {loading ? placeholderBlock() : imgBlock()}
            </Grid>
            <Grid item xs={12} md={5}>
              <InfoComponent
                listedItemId={listedItemId}
                deliveryType={deliveryType}
                isCurrentUserOwner={isCurrentUserOwner}
                itemCondition={itemCondition}
                currency={currency}
                city={city}
                region={region}
                description={description}
                locale={locale}
                loading={loading}
                name={name}
                state={state}
                listedUtc={listedUtc}
                createdUtc={createdUtc}
                soldUtc={soldUtc}
                nonprofitName={nonprofitName}
                nonprofitUrl={nonprofitUrl}
                donorName={donorName}
                isLocalPickupAvailable={isLocalPickupAvailable}
                isShippingAvailable={isShippingAvailable}
                setInStoreDeliveryType={setInStoreDeliveryType}
                currentPrice={currentPrice}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
